export const sendMessage = (message) => {
    return {
        type: 'SEND_MESSAGE',
        payload: message
    }
}
export const parsingMessage = (message) => {

}
/* 查找出包含的内容^[1]^，并解析包含的数组 */
export const extractAndConvertCaretArray = (str) => {
    // 步骤1：匹配^包裹的[1][2][3]部分（非贪婪匹配，避免多组干扰）
    const caretRegex = /\^(\[.*?\])\^/;
    const caretMatch = str.match(caretRegex);

    // 无匹配则返回空数组
    if (!caretMatch) return [];

    // 拿到^中间的核心内容，比如 "[1][2][3]"
    const coreStr = caretMatch[1];

    // 步骤2：提取所有数字（支持多位数，如[10][200][3]）
    const numRegex = /\[(\d+)\]/g;
    const numMatches = [];
    let numMatch;

    // 循环匹配所有[]中的数字
    while ((numMatch = numRegex.exec(coreStr)) !== null) {
        // 转换为数字类型并存入数组
        numMatches.push(Number(numMatch[1]));
    }
    console.log(numMatches)
    return numMatches;
}
/* 替换掉^[1]^包含的内容，将器替换为html */
export const replaceCaretWithSpan = (str, replaceIds) => {
    let replaceStr = ''
    for (let i = 0; i < replaceIds.length; i++) {
        replaceStr += `<span data-sign="true" data-index="${replaceIds[i]}" class="sign" style="color: #42b983;">${replaceIds[i]}</span>`
    }
    const outerRegex = /\^(\[.+?\])\^/g;
    // 替换逻辑：$1 引用正则中第一个捕获组（即数字）
    return str.replace(outerRegex, replaceStr);
}
export const $checkNetwork =  () => {
    return new Promise((resolve, reject) => {
        let url = process.env.VUE_APP_CHECKNETWORK
        let controller = new AbortController()
        let signal = controller.signal;
        let bool = false
        let sTime = Date.now()
        const clear = ()=>{
            clearInterval(timer)
            timer = null
        }
        const setStorage = (bool) => {
            sessionStorage.setItem('checkNetworkBool', bool + '')
        }
        let timer = setInterval(()=>{
            let eTime = Date.now()
            if(eTime - sTime > 200) {
                clear()
                setStorage(bool)
                resolve(bool)
            }
        }, 10)
        fetch(url, { signal })
            .then((res) => {
                if (!res.ok) {
                    throw new Error('网络请求失败')
                }
                return res.json()
            })
            .then((data) => {
                console.log(data)
                if (data.status === 200 && data.message === 'IAMINCAPOL') {
                    bool = true
                }
                clear()
                setStorage(bool)
                resolve(bool)
            })
            .catch((err) => {
                clear()
                setStorage(bool)
                resolve(bool)
            })
    })

}
